<script>
import { mapGetters } from 'vuex'

export default {
    name: 'ProfileNav',
    data() {
        return {
            profileNav: [
                { title: 'profile.account' },
                {
                    icon: 'fa-solid fa-cog',
                    label: 'profile.pages.general',
                    to: 'profile-general',
                },
                {
                    icon: 'fa-solid fa-sliders-h',
                    label: 'profile.pages.preferences',
                    to: 'profile-notifications',
                },
                { divider: 'lg' },
                {
                    icon: 'fa-solid fa-map-marker-alt',
                    label: 'profile.pages.addresses',
                    to: 'profile-addresses',
                },
                {
                    icon: 'fa-solid fa-wallet',
                    label: 'profile.pages.expense_rules',
                    to: 'profile-allowances',
                },
                {
                    icon: 'fa-solid fa-credit-card',
                    label: 'profile.pages.payment_methods',
                    to: 'profile-payment-methods',
                },
                {
                    icon: 'fa-solid fa-cube',
                    label: 'profile.pages.integrations',
                    to: 'profile-integrations',
                },
                { divider: 'xs' },
                { title: 'profile.orders' },
                {
                    icon: 'fa-solid fa-history',
                    label: 'profile.pages.orders',
                    to: 'profile-orders',
                    params: { page: 1 },
                },
            ],
        }
    },
    computed: {
        ...mapGetters(['smDevice']),
    },
    methods: {
        onTouch(e) {
            if (e.target.dataset.name !== this.$route.name) {
                this.$router.push(
                    {
                        name: e.target.dataset.name,
                        params: e.target.dataset.params
                            ? JSON.parse(e.target.dataset.params)
                            : undefined,
                    },
                    () => {
                        this.$emit('click')
                    }
                )
            } else {
                this.$emit('click')
            }
        },
    },
}
</script>

<template lang="pug">
.nav.flex-column.nav-pills.p-0(:class="{'bg-transparent': smDevice}")
    template(v-for="(nav, index) in profileNav")
        h2(v-if="nav.title" :key="`profileNavTitle-${nav.title}`" :class="{'mt-5': index}") {{ $t(nav.title) }}
        .dropdown-divider(
            v-else-if="nav.divider"
            :class="[nav.divider === 'xs' ? 'd-block' : `d-${nav.divider}-block`, 'd-none']"
            :key="`profileNavDivider-${index}`")
        router-link.nav-link.nav-link-icon(
            :class="{'active': $route.name === nav.to}"
            :key="`profileNav-${nav.label}`"
            :to="{name: nav.to, params: nav.params}"
            v-else)
            icon(:icon="nav.icon")
            | {{ $t(nav.label) }}

</template>
